module.exports = __webpack_public_path__ + "static/img/businessPowerIcon.ab579227.png";